<div *ngIf="dSS.dienststelle && dSS.modusErweitert" class="ride-group">
  <ion-row>
    <ion-col>
      <h3>Rad</h3>
    </ion-col>
  </ion-row>
</div>
<ion-row class="pt-2">
  <ion-col class="py-0">
    <ion-item lines="inset">
      <ion-input
        label="Bruttokaufpreis inkl. Zubehör"
        labelPlacement="floating"
        type="number"
        pattern="\d+(\.\d{1,2})?(,\d{1,2})?"
        [(ngModel)]="dSS.kaufpreis"
        (ionChange)="update($event)"
        placeholder="Angabe erforderlich!"
        [max]="dSS.dienststelle?.maxPreis"
        [min]="dSS.dienststelle?.minPreis"
        [required]="true"
        ><ion-icon
          *ngIf="!!dSS.kaufpreis"
          name="logo-euro"
          class="eur_logo__position"
        ></ion-icon
      ></ion-input>
    </ion-item>
    <ion-text color="danger" *ngIf="dSS.kaufpreis > dSS.dienststelle?.maxPreis">
      <p class="ion-padding-start ion-padding-top">
        Der Höchstpreis für das Dienstrad-Leasing liegt bei
        {{ dSS.dienststelle?.maxPreis }} €.
      </p>
    </ion-text>
  </ion-col>
</ion-row>

<ng-container *ngIf="dSS.modusErweitert">
  <ion-row class="pt-2">
    <ion-col class="py-0">
      <ion-item lines="inset">
        <ion-input
          label="UVP/Bruttolistenpreis des Herstellers"
          labelPlacement="floating"
          type="number"
          pattern="\d+(\.\d{1,2})?(,\d{1,2})?"
          [(ngModel)]="dSS.bruttoKaufUVP"
          (ionChange)="update($event)"
          placeholder="Angabe erforderlich!"
          [required]="true"
        ></ion-input>
      </ion-item>
      <ion-text
        color="danger"
        *ngIf="dSS.bruttoKaufUVP > dSS.dienststelle?.maxPreis"
      >
        <p class="ion-padding-start ion-padding-top">
          Der Höchstpreis für das Dienstrad-Leasing liegt bei
          {{ dSS.dienststelle?.maxPreis }} €.
        </p>
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-icon
    class="info_icon_select__position"
    name="information-circle-outline"
    (click)="dSS.showDiv('C')"
  >
  </ion-icon>
  <div *ngIf="dSS.currInfo == 'C'">
    <p class="RIDE-info">
      Die unverbindliche Preisempfehlung (UVP) versteht sich inklusive
      Mehrwertsteuer und Zubehör. Sie dient als Grundlage zur Berechnung des zu
      versteuernden geldwerten Vorteils.
    </p>
  </div>
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Radtyp"
            [(ngModel)]="dSS.bikeCategory"
            (ionChange)="update($event)"
          >
            <ion-select-option
              *ngFor="let option of getBikeCategoryOptions()"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
</ng-container>
